import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ChangelogService} from './changelog.service';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MarkdownModule} from 'ngx-markdown';
import {AlertComponent} from '../alert/alert.component';
import {AlertService} from '../alert/alert.service';
import {AbstractSigaleComponent} from '../abstract-sigale.component';

@Component({
	standalone: true,
	// tslint:disable-next-line:component-selector
	selector: 'changelog',
	templateUrl: './changelog.component.html',
	styleUrls: ['./changelog.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		MarkdownModule,
		AlertComponent
	]
})
export class ChangelogComponent extends AbstractSigaleComponent {

	loading = false;
	changelog: string;

	constructor(private http: HttpClient,
				private alertService: AlertService,
				private changelogService: ChangelogService) {
		super();
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.loading = true;
		this.changelogService.recupererChangelogs().subscribe(response => {
			this.loading = false;
			this.changelog = response;
		}, error => {
			this.loading = false;
			this.alertService.error(JSON.parse(error.error), 'changelogAlert');
		});
	}
}
